<template>
  <div class="devices">
    
    <!-- Content -->
    <div class="" style="height: 670px; overflow-y: hidden; overflow-x: hidden;">
      <div v-if="section=='default'" class="p-2 rounded" :class="{'disabled-div': addingDevice }" style="height: 670px;">
        <!-- Devices -->
        <div class="row">
          <div class="col-md-3" style="border-right: solid 2px rgb(50,50,50); height: 642px;">
            <div class="input-group flex-nowrap">
              <input class="btn text-white fw-light fs-4 text-start me-2" type="text" value="Devices" style="opacity: 1; letter-spacing: 5px; width: 80%" disabled>
              <button class="btn btn-kraken rounded" @click="getHello()">
                Hello
              </button>
              <button class="btn btn-kraken rounded fs-5 bg-gradient" style="width: 20%;" :disabled="gettingDevices || alteringDevice || deletingDevice || content_mode.includes('edition') || content_mode.includes('addition')" @click="getDevices">
                <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingDevices || alteringDevice || deletingDevice}"></i>
              </button>
            </div>
            <div class="input-group flex-nowrap mt-2">
              <button class="btn btn-kraken rounded bg-gradient fs-5 text-start me-1" style="width: 80%;" @click="content_mode='standard_devices_main'; device_type='standard_devices'; search_by='name'; getDevices(); roles = []; getRoles();" :class="{'selected-type': content_mode.includes('standard_devices')}" :disabled="gettingDevices">
                <i class="fa-solid fa-lg fa-desktop me-2"></i>
                <span class="me-1" :class="{'fa-fade': content_mode.includes('standard_devices')}">Standard </span>
                <span v-if="content_mode == 'standard_devices_main'">({{devices.length}})</span>
              </button>
              <div>
                <button class="btn btn-kraken rounded bg-gradient fs-5" style="width: 100%;" :class="{'selected-type': content_mode=='standard_devices_addition' }" @click="content_mode='standard_devices_addition'; device_type='standard_devices'; roles = []; getRoles(); clearNew();" :disabled="content_mode.includes('edition') || content_mode.includes('adition') || gettingDevices">
                  <span :class="{'fa-fade': content_mode.includes('standard_devices_addition')}">+1</span>
                </button>
                <button class="btn btn-kraken rounded bg-gradient fs-5 mt-1" style="width: 100%;" :class="{'selected-type': content_mode=='standard_devices_massive_addition' }"  @click="content_mode='standard_devices_massive_addition'; device_type='standard_devices';" :disabled="content_mode.includes('edition') || content_mode.includes('adition') || gettingDevices">
                  <span :class="{'fa-fade': content_mode.includes('standard_devices_massive_addition')}">+N</span>
                </button>
              </div>
            </div>
            <div class="input-group flex-nowrap mt-2">
              <button class="btn btn-kraken rounded bg-gradient fs-5 text-start" style="width: 100%;" @click="content_mode='cloud_devices_main'; device_type='cloud_devices'; search_by='name'; getDevices(); roles=[]; getRoles();" :class="{'selected-type': content_mode.includes('cloud_devices')}" :disabled="gettingDevices">
                <i class="fa-solid fa-lg fa-cloud me-2"></i>
                <span class="me-1" :class="{'fa-fade': content_mode.includes('cloud_devices')}">Cloud</span>
                <span v-if="content_mode.includes('cloud_devices')">({{devices.length}})</span>
              </button>
            </div>
          </div>
          <div class="col-md-9">
            <!-- Rest Area -->
            <div v-if="content_mode == 'restarea'" class="" style="">
              <div class="input-group flex-nowrap" style="margin-top: 25%;">
                <button v-if="!gettingDevices" class="btn bg-transparent text-white w-100 fs-1" style="opacity: 1;" disabled>
                  <i class="fa-solid fa-lg fa-arrow-left" :class="{'fa-fade': !gettingDevices}"></i>
                </button>
              </div>
              <span v-if="!gettingDevices" class="w-100 text-white fs-2">Select a device type.</span>
            </div>
            <!-- Filter Devices -->
            <div v-if="content_mode.includes('_main')" class="mb-2">
              <div class="input-group flex-nowrap">
                <input class="btn bg-input border-bottom-kraken fs-6 text-white" style="width: 40%; cursor: text;" type="text" placeholder="Search..." v-model="search_word">
                <select class="btn btn-kraken fs-6 rounded text-start" style="width: 20%;" v-model="search_by">
                  <option value="name">By Name</option>
                  <option value="alias">By Alias</option>
                  <option v-if="device_type=='standard_devices'" value="service_key">By Service Key</option>
                  <option v-if="device_type=='standard_devices'" value="ip">By IP Address</option>
                  <option v-if="device_type=='cloud_devices'" value="mac">By Mac</option>
                </select>
                <div style="width: 40%;"></div>
                <div class="text-info fs-3" style="width: 10%;">
                  <i class="fa-solid fa-fade" :class="{'fa-desktop': content_mode.startsWith('standard'), 'fa-cloud': content_mode.startsWith('cloud')}"></i>
                </div>
              </div>
            </div>
            <!--  >>>>> Standard Devices -->
            <!-- Rest Area -->
            <div v-show="content_mode == 'standard_devices_main' && gettingDevices" class="" style="">
              <div class="input-group flex-nowrap" style="margin-top: 25%;">
                <button v-if="gettingDevices" class="btn bg-transparent text-white w-100 fs-1" style="opacity: 1;" disabled>
                  <i class="fa-solid fa-lg fa-desktop text-info" :class="{'fa-fade': gettingDevices}"></i>
                </button>
              </div>
              <span v-if="gettingDevices" class="w-100 text-white fs-2" :class="{'fa-fade': gettingDevices}">Loading Standard Devices, please wait...</span>
            </div>
            <!-- Table-->
            <div v-show="content_mode == 'standard_devices_main' && !gettingDevices" class="">
              <!-- Header -->
              <div class="input-group flex-nowrap mb-1" style="overflow-y: scroll;">
                <button class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 10%;" disabled>
                  <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                </button>
                <select class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 10%;" v-model="imageType">
                  <option value="role">Role</option>
                  <option value="os">OS</option>
                </select>
                <select class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 25%;" v-model="searchType">
                  <option value="name">Name</option>
                  <option value="alias">Alias</option>
                  <option value="service_key">Service Key</option>
                </select>
                <button class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 25%;" disabled>
                  <i class="fa-solid fa-lg fa-network-wired"></i>
                </button>
                <button class="btn bg-kraken text-start fs-6 me-1" style="opacity: 1; width: 20%;" disabled>
                  Model
                </button>
                <button class="btn bg-kraken fs-6" style="opacity: 1; width: 25%;" disabled>
                  <i class="fa-solid fa-lg fa-bolt"></i>
                </button>
              </div>
              <!--  Main Content -->
              <div v-if="device_type=='standard_devices'" style="overflow-y: scroll; height: 545px;" class="border-bottom-kraken" :class="{'disabled-div': gettingDevices}">
                <div class="input-group flex-nowrap mb-1" v-for="(d, i) in filtered" v-bind:key="i+1">
                  <button class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 10%;" disabled>
                    {{i+1}}
                  </button>
                  <button v-if="imageType=='os'" class="btn bg-black fw-light fs-6 me-1 border-bottom-kraken" style="width: 10%;">
                    <img v-if="Object.keys(oss).includes(d.os)" :src="getImage(oss[d.os])" :title="oss[d.os].toUpperCase()" width="40" class="img-fluid rounded border-0">
                    <img v-if="!Object.keys(oss).includes(d.os)" :src="getImage('os')" title="Unknown OS." width="40" class="img-fluid rounded border-0">
                  </button>
                  <button v-if="imageType=='role'" class="btn bg-black fw-light fs-6 me-1 border-bottom-kraken" style="width: 10%;">
                    <img id="roleimg" :src="getImage(d.role)" :title="d.role.toUpperCase()" :alt="d.role" width="40" class="img-fluid rounded border-0">
                  </button>
                  <input type="text" class="btn bg-black border-bottom-kraken text-start text-white fw-bold me-1" style="opacity: 1; font-size: 13px; width: 25%; letter-spacing: 2px;" :value="d[searchType]" disabled>
                  <input type="text" class="btn bg-black border-bottom-kraken text-start text-white fw-bold me-1" style="opacity: 1; font-size: 13px; width: 25%; letter-spacing: 2px;" :value="d.ip" disabled>
                  <input type="text" class="btn bg-black border-bottom-kraken text-start fw-bold text-white me-2" style="opacity: 1; font-size: 12px; width: 20%; letter-spacing: 1px; cursor: default;" :value="d.model" :readonly="true">
                  <div class="input-group flex-nowrap" style="width: 25%; margin-top: 0px;">
                    <button v-if="false" class="btn fs-6 me-1" style="width: 34%;" :class="{'btn-dark': !d.active, 'btn-kraken bg-gradient': d.active}" @click="alternActive(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Turn On/Off: ${d.name}`">
                      <i class="fa-solid fa-lg fa-triangle-exclamation"></i>
                    </button>
                    <button v-if="false" class="btn fs-6 me-1" style="width: 34%;" :class="{'btn-dark': !d.ticket, 'btn-success bg-gradient': d.ticket}" @click="alternActive(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Turn On/Off tickets sending: ${d.name}`">
                      <i class="fa-solid fa-lg fa-ticket"></i>
                    </button>
                    <button class="btn fs-6 me-1" style="width: 34%;" :class="{'btn-dark': !d.active, 'btn-kraken bg-gradient': d.active}" @click="alternActive(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Turn On/Off: ${d.name}`">
                      <i class="fa-solid fa-lg fa-power-off"></i>
                    </button>
                    <button class="btn btn-kraken bg-gradient fs-6 me-1" style="width: 33%; text-shadow: 3px 5px 4px rgb(0,0,0);" @click="setEdition(d, i); content_mode='standard_devices_edition'; device_type='standard_devices'" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Edit: ${d.name}`">
                      <i class="fa-solid fa-lg fa-pen"></i>
                    </button>
                    <button class="btn btn-danger text-black bg-gradient fs-6" style="width: 33%; text-shadow: 3px 5px 4px rgb(180,0,0);" @click="deleteDevice(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Delete: ${d.name}`">
                      <i class="fa-solid fa-lg fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Adition -->
            <div v-if="content_mode=='standard_devices_addition'">
              <div>
                <!--Header -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="input-group flex-nowrap">
                      <input type="text" class="btn text-info text-start fs-4 fw-light" style="opacity: 1; letter-spacing: 4px; width: 30%;" value="New Device" disabled>
                      <input type="text" class="btn text-white text-start fs-6 fw-light" style="width: 50%; opacity: 1; letter-spacing: 2px;" :value="message" disabled>
                      <button class="btn fs-5 rounded me-2 bg-gradient" style="width: 10%;" :class="{'btn-kraken': online_mode, 'btn-dark':!online_mode }" @click="setOnlineMode" :disabled="gettingCredentials || inspectingDevice || addingDevice ">
                        <i class="fa-solid" :class="{'fa-link': online_mode, 'fa-link-slash': !online_mode}"></i>
                      </button>
                      <button class="btn btn-kraken bg-gradient fs-5 me-2 rounded" style="width: 10%;" @click="clearNew" :disabled="gettingCredentials || inspectingDevice || addingDevice ">
                        <i class="fa-solid" :class="{'fa-broom': !gettingCredentials, 'fa-spinner fa-spin': gettingCredentials}"></i>
                      </button>
                      <button class="btn btn-danger bg-gradient fs-5 rounded" style="width: 10%;" @click="content_mode='standard_devices_main'; online_mode=true; clearNew(); getDevices();">
                        <i class="fa-solid fa-close"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Settings -->
                <div class="row mt-3">
                  <!-- IP to Inspect (NOA)-->
                  <div class="col-md-5">
                      <div class="input-group flex-nowrap" :class="{'disabled-div': inspectingDevice || addingDevice || block_ip}">
                        <button class="btn btn-kraken fs-6" style="width: 15%; pointer-events: none;" title="Device IP" tabindex="9">
                          <i class="fa-solid fa-xl fa-network-wired"></i>
                        </button>
                        <input class="btn bg-black border-kraken text-white fs-6" type="text" placeholder="Device IP" style="cursor: text; width: 85%;" v-model="noa.ip">
                      </div>
                  </div>
                  <!-- Role (NOA) -->
                  <div :class="{'col-md-3': online_mode, 'col-md-7': !online_mode}">
                    <select v-model="noa.role" class="btn btn-kraken fs-6 fw-light rounded w-100 bg-gradient" title="Device Role" @change="setIcon(); getCredentials(); selected_credential=null;" :disabled="inspectingDevice || addingDevice || gettingRoles || block_role">
                      <option :value="null">Role...</option>
                      <option v-for="(role, i) in roles.filter( _role =>  !forbiddenRoles.includes(_role.name.toLowerCase()) )" v-bind:key="i+1" :value="role">{{capitalize(role.name)}}</option>
                    </select>
                  </div>
                  <!-- Credential -->
                  <div v-if="online_mode" class="col-md-3">
                    <select v-if="online_mode" v-model="selected_credential" class="btn btn-kraken fs-6 fw-light rounded w-100" :disabled="inspectingDevice || deviceFound || addingDevice || credentials.length==0 || !online_mode">
                      <option :value="null">Credential...</option>
                      <option v-for="(credential, i) in credentials" v-bind:key="i+1" :value="credential.uid">{{credential.username}}</option>
                    </select>
                  </div>
                  <!-- Inspect (NOA) -->
                  <div v-if="online_mode" class="col-md-1">
                    <!-- ONLINE -->
                    <button class="btn fs-6 w-100" :class="{'btn-kraken': !inspectingDevice || deviceFound, 'btn-info': inspectingDevice }" @click="inspectDevice" :disabled="inspectingDevice || deviceFound || addingDevice || credentials.length==0 || !noa.role || selected_credential == null ">
                      <i class="fa-solid fa-lg" :class="{'fa-magnifying-glass': !inspectingDevice, 'fa-refresh fa-spin': inspectingDevice }"></i>
                    </button>
                  </div>
                </div>
                <!-- Complete the information for new device. -->
                <div class="row mt-2">
                  <div class="col-md-5">
                    <!-- Name (NOA) -->
                    <div class="input-group flex-nowrap mt-1" :class="{'disabled-div': addingDevice || inspectingDevice || !deviceFound}">
                      <button class="btn btn-kraken fs-6" style="width: 15%; pointer-events: none;" title="Device Name" tabindex="9">
                        <i class="fa-solid fa-xl fa-desktop"></i>
                      </button>
                      <input class="btn bg-input border-kraken text-white fs-6 fw-light"  style="cursor: text; width: 85%" type="text" title="Name" placeholder="Name" v-model="noa.name">
                    </div>
                    <!-- Alias (NOA) -->
                    <div class="input-group flex-nowrap mt-2" :class="{'disabled-div': addingDevice || inspectingDevice || !deviceFound}">
                      <button class="btn btn-kraken fs-6" style="width: 15%; pointer-events: none;" title="Device Alias" tabindex="9">
                        <i class="fa-solid fa-xl fa-id-badge"></i>
                      </button>
                      <input class="btn bg-input border-kraken text-white fs-6 fw-light"  style="cursor: text; width: 85%" type="text" title="Alias" placeholder="Alias" v-model="noa.alias">
                    </div>
                    <!-- Service Key & Tickets (NOA) -->
                    <div class="input-group flex-nowrap mt-2" :class="{'disabled-div': addingDevice || inspectingDevice || !deviceFound}">
                      <button class="btn btn-kraken fs-6" style="width: 15%; pointer-events: none;" title="Device Service Key" tabindex="9">
                        <i class="fa-solid fa-xl fa-tag"></i>
                      </button>
                      <input class="btn bg-black border-kraken text-white fs-6 fw-light"  style="cursor: text; width: 70%" type="text" title="Service Key" placeholder="Service Key" v-model="noa.serkey">
                      <button class="btn fs-6" :class="{'btn-success': noa.ticket, 'btn-dark': !noa.ticket}" style="width: 15%;" title="Activate/Deactivate Ticket sending for device." @click="noa.ticket = !noa.ticket">
                        <i class="fa-solid fa-xl fa-ticket"></i>
                      </button>
                    </div>
                    <!-- City (NOA) -->
                    <div class="input-group flex-nowrap mt-2" :class="{'disabled-div': addingDevice || inspectingDevice || !deviceFound}">
                      <button class="btn btn-kraken fs-6" style="pointer-events: none; width: 15%;" title="Device City" tabindex="9" readonly>
                        <i class="fa-solid fa-xl fa-city"></i>
                      </button>
                      <select v-model="noa.city" class="btn border-kraken bg-input fs-6 fw-light rounded" style="width: 85%;" title="Device City">
                        <option :value="null">Select a city...</option>
                        <option v-for="(city, i) in cities" v-bind:key="i+1" :value="city">{{city.name}}</option>
                      </select>
                    </div>
                  <!-- OS & Role (NOA) -->
                  <div class="input-group flex-nowrap mt-1">
                      <div class="bg-black w-50 rounded" :class="{'disabled-div': addingDevice || inspectingDevice || !deviceFound }">
                        <img :src="getImage(oss[noa.os])" :alt="noa.os" width="175" class="img-fluid rounded border-0">
                      </div>
                      <div class="bg-black w-50 rounded" :class="{'disabled-div': addingDevice || inspectingDevice || !deviceFound }">
                        <img :src="getImage(noa.role)" :alt="noa.role" width="175" class="img-fluid rounded border-0">
                      </div>
                  </div>
                  <!-- Add Button-->
                  <button class="btn bg-gradient fs-2 w-100 mt-2" :class="{'btn-kraken': deviceFound && !addingDevice, '': !deviceFound, 'btn-success': deviceFound && addingDevice}"  :disabled="!deviceFound || addingDevice" @click="addDevice">
                    <i class="fa-solid fa-xl" :class="{'fa-refresh fa-spin': addingDevice, 'fa-plus':!addingDevice }"></i>
                  </button>
                  </div>
                  <div class="col-md-7">
                      <!-- Latitude & Longitude -->
                      <div :class="{'disabled-div': addingDevice || inspectingDevice || !deviceFound }">
                          <Locator ref="DeviceLocation"
                                  :key="locatorKey"
                                  mapHeight="393" 
                                  :zoom="zoom"
                                  :icons="icons" 
                                  :marker="noa.marker"
                                  :centerLatitude="centerLatitude" 
                                  :centerLongitude="centerLongitude"
                                  :mapKey="mapKey"/>
                      </div>
                      <!-- Latitude & Longitude Controls (NOA) -->
                      <div class="input-group flex-nowrap">
                        <button class="btn btn-kraken" style="width: 25%;" :disabled="!deviceFound || addingDevice">
                          <i class="fa-solid fa-xl fa-arrow-down me-2"></i>
                          <i class="fa-solid fa-xl fa-globe me-2"></i>
                          <i class="fa-solid fa-xl fa-arrow-up"></i>
                        </button>
                        <input class="btn btn-dark fs-5 fw-light rounded me-1" type="number" step="0.1" style="width: 36%;" v-model="noa.marker.position.lat" :disabled="!deviceFound || addingDevice" @click="locatorKey+=1" @change="locatorKey+=1">
                        <button class="btn" :class="{'btn-kraken': deviceFound, 'btn-dark': !deviceFound}" style="width: 25%;" :disabled="!deviceFound || addingDevice">
                          <i class="fa-solid fa-xl fa-arrow-left me-2"></i>
                          <i class="fa-solid fa-xl fa-globe me-2"></i>
                          <i class="fa-solid fa-xl fa-arrow-right"></i>
                        </button>
                        <input class="btn btn-dark fs-5 fw-light rounded" type="number" step="0.1" style="width: 35%;" v-model="noa.marker.position.lng" :disabled="!deviceFound || addingDevice" @click="locatorKey+=1" @change="locatorKey+=1">
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Massive Adition -->
            <div v-if="content_mode=='standard_devices_massive_addition'" class="p-2 rounded" style="height: 600px;">
              <div>
                <!--Header -->
                <div>
                  <div>
                    <div class="input-group flew-nowrap">
                      <div style="width:30%;"></div>
                      <input type="text" class="btn text-info fs-4 fw-light" style="opacity: 1; letter-spacing: 4px; width: 40%;" value="Massive Addition" disabled>
                      <div style="width:25%;"></div>
                      <button class="btn btn-danger bg-gradient fs-6 rounded" style="width: 5%;" @click="content_mode='standard_devices_main'; getDevices();" :disabled="uploadingFile">
                        <i class="fa-solid fa-xl fa-close"></i>
                      </button>
                    </div>
                    <div class="mt-2">
                      <input type="text" class="btn text-white text-center fs-6 fw-light" style="opacity: 1; letter-spacing: 4px; width: 100%;" :value="message" disabled>
                    </div>
                    <div class="input-group flew-nowrap mt-2">
                      <div style="width:40%;"></div>
                      <form :action="exampleExcelFile" method="GET" target="downframe" style="width: 10%;" class="btn btn-kraken bg-gradient rounded me-1 p-0">
                        <button class="btn btn-kraken fs-6 text-white w-100" type="submit" style="text-shadow: 3px 5px 4px Black;" title="Get the excel example file.">
                          <i class="fa-solid fa-xl fa-file-excel"></i>
                        </button>
                        <iframe id="downframe" name="downframe" src="" frameborder="0" style="display: none;"></iframe>
                      </form>
                      <button class="btn btn-kraken bg-gradient fs-6 rounded me-1" style="width: 10%;" @click="clearMassive" :disabled="uploadingFile">
                        <i class="fa-solid fa-xl fa-broom"></i>
                      </button>
                      
                    </div>
                  </div>
                </div>
                <!--Excel Loader -->
                <div class="">
                  <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                      <div class="" style="margin-top: 5%;">
                        <label for="formFile" class="form-label text-white fs-6">Upload your data in .xlsx format.</label>
                        <form id="excelForm">
                          <input class="form-control bg-dark text-white" type="file" accept=".xlsx" id="devicesFile" :disabled="uploadingFile">
                        </form>
                        <button class="btn btn-kraken bg-gradient fs-6 w-100 mt-2" type="button" @click="uploadDevicesFile" :disabled="uploadingFile">
                          <i v-show="!uploadingFile" class="fa-solid fa-xl fa-upload"></i>
                          <i v-show="uploadingFile"  class="fa-solid fa-xl fa-spinner fa-spin"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                </div>
                <div class="row mt-4" v-show="details.length > 0">
                  <p class="form-label text-white fs-4">{{uploadMessage}}</p>
                </div>
                <div v-show="details.length > 0" class="mt-2" style="overflow-y: auto; overflow-x: hidden; height: 300px;">
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                      <ul class="list-group">
                        <li v-for="(detail, i) in details" v-bind:key="i+1" class="list-group-item bg-danger text-white">{{detail}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- >>>>>> Cloud Devices   -->
            <!-- Rest Area -->
            <div v-show="content_mode == 'cloud_devices_main' && gettingDevices" class="" style="">
              <div class="input-group flex-nowrap" style="margin-top: 25%;">
                <button v-if="gettingDevices" class="btn bg-transparent text-white w-100 fs-1" style="opacity: 1;" disabled>
                  <i class="fa-solid fa-lg fa-cloud text-primary" :class="{'fa-fade': gettingDevices}"></i>
                </button>
              </div>
              <span v-if="gettingDevices" class="w-100 text-white fs-2" :class="{'fa-fade': gettingDevices}">Loading Cloud Devices, please wait...</span>
            </div>
            <!-- Table-->
            <div v-show="content_mode == 'cloud_devices_main' && !gettingDevices" class="">
              <!-- Header -->
              <div class="input-group flex-nowrap mb-1" style="overflow-y: scroll;">
                <button class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 10%;" disabled>
                  <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                </button>
                <select class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 15%;" v-model="imageType">
                  <option value="role">Role</option>
                  <option value="os">OS</option>
                </select>
                <select class="btn bg-kraken text-start fs-6 me-1" style="opacity: 1; width: 30%;" v-model="searchType">
                  <option value="name">Name</option>
                  <option value="alias">Alias</option>
                </select>
                <button class="btn bg-kraken text-start fs-6 me-1" style="opacity: 1; width: 30%;" disabled>
                  Mac Address
                </button>
                <button class="btn bg-kraken text-start fs-6 me-1" style="opacity: 1; width: 20%;" disabled>
                  Model
                </button>
                <button class="btn bg-kraken fs-6" style="opacity: 1; width: 10%;" disabled>
                  <i class="fa-solid fa-lg fa-bolt"></i>
                </button>
              </div>
              <!--  Main Content -->
              <div v-if="device_type=='cloud_devices'" style="overflow-y: scroll; height: 545px;" :class="{'disabled-div': gettingDevices}">
                <div class="input-group flex-nowrap mb-1" style="" v-for="(d, i) in filtered" v-bind:key="i+1">
                  <button class="btn bg-kraken fs-6 me-1" style="opacity: 1; width: 10%;" disabled>
                    {{i+1}}
                  </button>
                  <button v-if="imageType=='os'" class="btn bg-black border-bottom-kraken fw-light fs-6 me-1" style="width: 15%;">
                    <img v-if="Object.keys(oss).includes(d.os)" :src="getImage(oss[d.os])" :title="oss[d.os].toUpperCase()" width="50" class="img-fluid rounded border-0">
                    <img v-if="!Object.keys(oss).includes(d.os)" :src="getImage('os')" title="Unknown OS." width="50" class="img-fluid rounded border-0">
                  </button>
                  <button v-if="imageType=='role'" class="btn bg-black border-bottom-kraken fw-light fs-6 me-1" style="width: 15%;">
                    <img id="roleimg" :src="getImage(d.role)" :title="d.role.toUpperCase()" :alt="d.role" width="50" class="img-fluid rounded border-0">
                  </button>
                  <input type="text" class="btn bg-black border-bottom-kraken text-start fw-bold text-white me-1" style="opacity: 1; font-size: 13px; width: 30%; letter-spacing: 1px;  cursor: default;" :value="d[searchType]" :readonly="true">
                  <input type="text" class="btn bg-black border-bottom-kraken text-start fw-bold text-white me-1" style="opacity: 1; font-size: 13px; width: 30%; letter-spacing: 1px;  cursor: default;" :value="d.mac" :readonly="true">
                  <input type="text" class="btn bg-black border-bottom-kraken text-start fw-bold text-white me-2" style="opacity: 1; font-size: 13px; width: 20%; letter-spacing: 1px;  cursor: default;" :value="d.model" :readonly="true">
                  <div class="input-group flex-nowrap" style="width: 10%;">
                    <button v-if="false" class="btn fs-6 me-1" style="width: 33%;" :class="{'btn-dark': !d.active, 'bg-kraken bg-gradient': d.active}" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Turn On/Off: ${d.name}`">
                      <i class="fa-solid fa-lg fa-power-off"></i>
                    </button>
                    <button class="btn btn-kraken bg-gradient fs-6 rounded" style="width: 100%;" @click="setEdition(d, i); content_mode='cloud_devices_edition'; device_type='cloud_devices'" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Edit: ${d.name}`">
                      <i class="fa-solid fa-lg fa-pen"></i>
                    </button>
                    <button v-if="false" class="btn bg-danger text-black bg-gradient fs-6" style="width: 33%;" @click="deleteDevice(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Delete: ${d.name}`">
                      <i class="fa-solid fa-lg fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Edition shared by [standard_devices, cloud_devices]-->
            <div v-show="['standard_devices_edition','cloud_devices_edition'].includes(content_mode)">
              <div class="rounded" style="height: 585px;" :class="{ 'disabled-div': alteringDevice }">
                <div class="row" :class="{ 'disabled-div': alteringDevice }">
                  <div class="col-md-12">
                    <!-- Selected device. -->
                    <div class="input-group flex-nowrap">
                      <button type="text" class="btn bg-black text-info text-start fs-6" style="opacity: 1; width: 5%;" disabled>
                        <i class="fa-solid fa-xl fa-fade fa-pen me-1"></i>
                      </button>
                      <div class="btn text-info text-start fs-5" style="pointer-events:none; width: 80%;">
                        {{labels[device_type]}}  - Edition
                      </div>
                      <button class="btn btn-kraken bg-gradient fs-6 rounded me-3" style="width: 10%;" @click="editDevice">
                        <i class="fa-solid fa-xl fa-save"></i>
                      </button>
                      <button class="btn btn-danger bg-gradient fs-6 rounded" style="width: 5%;" @click="clearEdition"> 
                        <i class="fa-solid fa-close"></i>
                      </button>
                    </div>
                    <div class="input-group flex-nowrap mt-1">
                      <button class="btn fw-bold bg-kraken fs-5 me-1" style="width:10%; pointer-events: none;"> 
                        {{editNumber}}
                      </button>
                      <button class="btn bg-kraken fs-6" style="width: 20%; pointer-events; none;" title="Device Name | Network ID"> 
                        <i class="fa-solid fa-xl fa-desktop me-1"></i>
                        <i class="fa-solid fa-xl">/</i>
                        <i class="fa-solid fa-xl fa-network-wired ms-1"></i>
                      </button>
                      <input v-if="editedDevice.category == 'network_elements'" class="btn bg-input text-info text-start fs-6 border-bottom-kraken" style="width: 95%; cursor:text; text-transform: uppercase; pointer-events:none;" type="text" title="Device Name / IP address" :value="`${editName} / ${editedDevice.ip}`" readonly>
                      <input v-if="editedDevice.category == 'cloud_controlled'" class="btn bg-input text-info text-start fs-6 border-bottom-kraken" style="width: 95%; cursor:text; text-transform: uppercase; pointer-events:none;" type="text" title="Device name / Mac address" :value="`${editName} / ${editedDevice.mac}`" readonly>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mt-3">
                    <button type="text" class="btn text-start text-info fs-5 w-100" style="opacity: 1; pointer-events: none;" disabled>
                      General:
                    </button>
                    <!-- Device Alias -->
                    <div class="input-group flex-nowrap">
                      <button class="btn bg-kraken fs-6" style="width: 15%;" title="Device Alias"> 
                        <i class="fa-solid fa-xl fa-id-badge"></i>
                      </button>
                      <input class="btn bg-input text-info text-start fs-6 border-bottom-kraken" placeholder="Device Alias" style="width: 85%; cursor:text;" type="text" v-model="editAlias" title="Device Alias">
                    </div>
                    <!-- Device Service Key -->
                    <div class="input-group flex-nowrap mt-2">
                      <button class="btn bg-kraken fs-6" style="width: 15%;" title="Device Service Key"> 
                        <i class="fa-solid fa-xl fa-tag"></i>
                      </button>
                      <input class="btn bg-black text-info text-start fs-6 border-bottom-kraken" placeholder="Device Service Key" style="width: 70%; cursor:text;" type="text" v-model="editSerkey" title="Device Service Key">
                      <button class="btn fs-6" style="width: 15%;" title="Send/Not Send ticket." :class="{'btn-success': editTicket, 'bg-kraken': !editTicket }" @click="editTicket = !editTicket"> 
                        <i class="fa-solid fa-xl fa-ticket"></i>
                      </button>
                    </div>
                    <!-- Device Role -->
                    <div class="input-group flex-nowrap rounded mt-2" :class="{'disabled-div': device_type=='cloud_devices'}">
                      <div class="bg-black border-kraken p-1" style="width: 30%;">
                        <img :src="getImage(editRole.name)" :alt="newRole.name" width="40" class="img-fluid rounded border-0">
                      </div>
                      <select v-model="editRole" class="btn bg-kraken fs-6 fw-light" style="width: 70%;" title="Device Role" @change="setEditIcon">
                        <option v-for="(role, i) in roles" v-bind:key="i+1" :value="role">{{capitalize(role.name)}}</option>
                      </select>
                    </div>
                    <!-- Device City -->
                    <div class="input-group flex-nowrap rounded mt-2">
                      <div class="bg-black border-kraken p-1" style="width: 30%;">
                        <img src="@/assets/img/bases/general/base_city.png" :alt="newRole.name" width="40" class="img-fluid rounded border-0 me-1">
                      </div>
                      <select v-model="editCity" class="btn bg-kraken fs-6 fw-light" style="width: 70%;" title="Device City">
                        <option value="invalid">Select a city...</option>
                        <option v-for="(city, i) in cities" v-bind:key="i+1" :value="city">{{city.name}}</option>
                      </select>
                    </div>
                    <!-- Device Credential -->
                    <div class="input-group flex-nowrap rounded mt-2" title="Device credentials." :class="{'disabled-div': credless_cats.includes(this.editRole.category)}">
                      <button class="btn border-kraken bg-gradient text-info p-1" style="width: 30%" @click="getCredentials('edition')">
                        <i class="fa-solid fa-xl fa-key"></i>
                      </button>
                      <select v-model="editCred" class="btn bg-kraken fs-6 fw-light" style="width: 70%;" title="Credential to authenticate with the device." :disabled="gettingCredentials || editedDevice.os == 'superficial'">
                        <option :value="null">Select a credential...</option>
                        <option v-for="(crd, id_cred) in credentials_fed" v-bind:key="id_cred+1" :value="crd.uid">{{`${crd.name} - ${crd.alias}`}}</option>
                      </select>
                    </div>
                    <!-- Location -->
                    <button type="text" class="btn text-start text-info fs-5 w-100 mt-3" style="opacity: 1; pointer-events: none;" disabled>
                      Location:
                    </button>
                    <div class="input-group flex-nowrap">
                      <button class="btn bg-kraken text-white fs-6" style="width: 30%">
                        <i class="fa-solid fa-arrow-down me-2"></i>
                        <i class="fa-solid fa-globe me-2"></i>
                        <i class="fa-solid fa-arrow-up"></i>
                      </button>
                      <input class="btn bg-input border-bottom-kraken fs-6 fw-light text-info" style="width: 70%" type="number" step="0.1" v-model="editDeviceMarker.position.lat" @change="editLocatorKey+=1;" :disabled="device_type == 'cloud_devices'">
                    </div>
                    <div class="input-group flex-nowrap mt-2">
                      <button class="btn bg-kraken text-white fs-6" style="width: 30%">
                        <i class="fa-solid fa-arrow-left me-2"></i>
                        <i class="fa-solid fa-globe me-2"></i>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                      <input class="btn bg-input border-bottom-kraken fs-6 fw-light text-info" style="width: 70%" type="number" step="0.1" v-model="editDeviceMarker.position.lng" @change="editLocatorKey+=1;" :disabled="device_type == 'cloud_devices'">
                    </div>
                    <!-- Finished. -->
                    
                  </div>
                  <div class="col-md-8" :class="{ 'disabled-div': alteringDevice }">
                    <!-- Location -->
                      <div v-if="device_type == 'standard_devices'" name="editionMap">
                        <div class="p-2 bg-black rounded mt-1">
                          <div class="bg-input p-2 rounded mt-1">
                            <Locator ref="editDeviceLocation"
                                        :key="editLocatorKey"
                                        mapHeight="420" 
                                        :zoom="editZoom"
                                        :icons="icons" 
                                        :marker="editDeviceMarker"
                                        :centerLatitude="editCenterLatitude" 
                                        :centerLongitude="editCenterLongitude"
                                        :mapKey="mapKey"/>
                          </div>
                        </div>
                      </div>
                      <div v-if="device_type!='standard_devices'" class="text-info border border-dark rounded mt-2" style="height: 100%;">
                        <div style="margin-top: 35%;" class="fs-4">Map unavailable for this type of device.</div>
                      </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'
import Locator from '@/components/apps-components/suite/subs/Locator.vue'
import axios from "axios";

export default {
  name: 'Devices',
  components: {
    Locator
  },
  data(){
    return {
      // General
      site: null,
      stage: null,
      device_type: 'standard_devices',
      content_mode: 'restarea',
      // Labels
      labels: {
        'standard_devices': 'Standard Devices',
        'cloud_devices': 'Cloud Devices'
      },

      // Sections
      section: 'default',
      action: "default",
      acting: false,
      actionMessage: "Hello",
      message: "...",
      online_mode: true,
      // Cities &  Roles
      cities: [],
      gettingCities: false,
      roles: [],
      gettingRoles: false,
      // Devices
      devices: [],
      gettingDevices: false,
      devicesMessage: "...",
      selected_device: "invalid",
      // New or Addition
      noa: {
        ip: null,
        name: null,
        alias: null,
        ticket: true,
        serkey: null,
        city: null,
        role: null,
        os: null,
        marker: {
            name: "Name",
            type: "role",
            position: { lat: 25.0, lng: -100.0 },
            icon: "role",
            size: [30, 45],
            anchor: [15, 22],
            draggable: false
        }
      },
      defnoa: {
        ip: null,
        name: null,
        alias: null,
        ticket: true,
        serkey: null,
        city: null,
        role: null,
        os: null,
        marker: {
            name: "Name",
            type: "role",
            position: { lat: 25.0, lng: -100.0 },
            icon: "role",
            size: [30, 45],
            anchor: [15, 22],
            draggable: false
        }
      },
      block_ip: false,
      block_role: false,

      // Delete Device
      deletingDevice: false,

      // Edit Device
      alteringDevice: false,
      editionMode: false,
      editLocatorKey: 0,
      editZoom: 6,
      editNumber: null,
      editName: null,
      editAlias: null,
      editSerkey: null,
      editTicket: null,
      editCenterLatitude: 0,
      editCenterLongitude: 0,
      editCity: "invalid",
      editedDevice: {},
      defaultEditRole: {name: "invalid", uid: null},
      editRole: {name: "invalid", uid: null},
      editDeviceMarker: {
            name: "Name",
            type: "role",
            position: { lat: 25.0, lng: -100.0 },
            icon: "role",
            size: [30, 45],
            anchor: [15, 22],
            draggable: false
      },
      editCred: null,

      // New Device & Inspection
      addingDevice: false,
      inspectingDevice: false,
      deviceFound: false,
      newDeviceIP: "",
      newDeviceName: "Name",
      newDeviceAlias: "Alias",
      newDeviceOs: "os",
      newCity: "invalid",
      newRole: "role",
      forbiddenRoles: [
        'firewall',
        'accesspoint'
      ],
      defaultMarker: {
            name: "Name",
            type: "role",
            position: { lat: 25.0, lng: -100.0 },
            icon: "role",
            size: [30, 45],
            anchor: [15, 22],
            draggable: false
      },
      newDeviceMarker: {
            name: "Name",
            type: "role",
            position: { lat: 25.0, lng: -100.0 },
            icon: "role",
            size: [30, 45],
            anchor: [15, 22],
            draggable: false
      },
      // Credentials
      selected_credential: null,
      credentials: [],
      credentials_fed: [],
      gettingCredentials: false,
      // Map
      zoom: 4.5,
      centerLatitude: 24.41322,
      centerLongitude: -101.219482,
      locatorKey: 0,
      // Massive Addition
      exampleExcelFile: null,
      uploadingFile: false,
      uploadMessage: "Hello",
      details: [],
      // Locator
      icons: {
          router : require("@/assets/icons/router.png"),
          router_alert : require("@/assets/icons/router-alert.png"),
          router_fail : require("@/assets/icons/router-fail.png"),
          switch: require("@/assets/icons/switch.png"),
          switch_alert: require("@/assets/icons/switch-alert.png"),
          switch_fail: require("@/assets/icons/switch-fail.png"),
          server: require("@/assets/icons/server.png"),
          server_alert: require("@/assets/icons/server-alert.png"),
          server_fail: require("@/assets/icons/server-fail.png"),
          accesspoint: require("@/assets/icons/ap.png"),
          firewall: require("@/assets/icons/firewall.png"),
          firewall_alert: require("@/assets/icons/firewall.png"),
          firewall_fail: require("@/assets/icons/firewall.png"),
          other: require("@/assets/icons/other.png"),
          other_alert: require("@/assets/icons/other-alert.png"),
          other_fail: require("@/assets/icons/other-fail.png"),
          check: require("@/assets/icons/check.png"),
          fail: require("@/assets/icons/fail.png"),
          marker: require("@/assets/icons/marker.png"),
          role: require("@/assets/icons/marker.png")
      },
      // Icons Size-Anchor
      icons_sa:{
          router: {size: [40, 32], anchor: [20, 20]},
          switch: {size: [40, 32], anchor: [20, 20]},
          server: {size: [33, 28], anchor: [20, 20]},
          accesspoint: {size: [50, 40], anchor: [20, 12]},
          firewall: {size: [50, 28], anchor: [25, 5]},
          role: {size: [30, 45], anchor: [15, 22]},
          other: {size: [30, 30], anchor: [15, 15]}
      },
      bases: {
          // Empty
          unknown: require("@/assets/img/bases/null.png"),
          // Device Roles
          role: require("@/assets/img/bases/roles/default_device_role.png"),
          router: require("@/assets/img/bases/roles/base_router.png"),
          switch: require("@/assets/img/bases/roles/base_switch.png"),
          server: require("@/assets/img/bases/roles/base_server.png"),
          accesspoint: require("@/assets/img/bases/roles/base_ap.png"),
          firewall: require("@/assets/img/bases/roles/base_firewall.png"),
          other: require("@/assets/img/bases/roles/base_other.png"),
          // Device OS's
          ios: require("@/assets/img/bases/os/base_cisco_ios.png"),
          iosxr: require("@/assets/img/bases/os/base_cisco_xr.png"),
          iosxe: require("@/assets/img/bases/os/base_cisco_xe.png"),
          reap: require("@/assets/img/bases/os/base_reap.png"),
          reap2900: require("@/assets/img/bases/os/base_reap_2900.png"),
          rax700: require("@/assets/img/bases/os/base_reap_rax700.png"),
          ros: require("@/assets/img/bases/os/base_ros.png"),
          ros2800: require("@/assets/img/bases/os/base_ros_2800.png"),
          timos: require("@/assets/img/bases/os/base_timos.png"),
          vrp: require("@/assets/img/bases/os/base_vrp.png"),
          huawei: require("@/assets/img/bases/os/base_huawei.png"),
          ubuntu: require("@/assets/img/bases/os/base_ubuntu.png"),
          meraki: require("@/assets/img/bases/os/base_meraki.png"),
          aruba: require("@/assets/img/bases/os/base_aruba.png"),
          superficial: require("@/assets/img/bases/os/base_superficial.png"),
          // Devices Types
          standard_devices: require("@/assets/img/bases/devices/standard_devices.png"),
          cloud_devices: require("@/assets/img/bases/devices/cloud_devices.png")
      },
      oss:{
          null:         'unknown',
          os:           'os',
          ios:          'ios',
          iosxr:        'iosxr',
          iosxe:        'iosxe',
          huawei:       'vrp',
          alu:          'timos',
          raisecom2900: 'reap2900',
          raisecom2800: 'ros2800',
          rax700:       'rax700',
          ubuntu:       'ubuntu',
          meraki:       'meraki',
          superficial:  'superficial'
      },
      credless_cats: ['cloud_controlled'],
      mapKey: null,
      // Filtering
      search_word: null,
      search_by: 'name',


      searchWord: "",
      searchType: "name",
      imageType: "role"


    }
  },
  methods:{
    // Devices
    getHello(){
      const params = { demo: this.search_by}
      const dest = this.site + '/suite/devices/devices-hello'
      axios
          .get(dest, {params})
          .then(rx => {
            // OK
            console.log(rx.data)
          })
          .catch(error => {
            //
      });
    },
    getDevices(){
      this.devicesMessage = "Getting devices..."
      this.gettingDevices = true
      this.clearEdition()
      this.devices = []
      const params = { devtype: this.device_type }
      const dest = this.site + '/suite/devices/getDevices'
      axios
          .get(dest, {params})
          .then(rx => {
            // OK
            this.devices = rx.data.devices
            this.gettingDevices = false
            this.devicesMessage = "..."
            //this.getRoles()
          })
          .catch(error => {
            this.devicesMessage = this.processErrorMessage(error)
            this.devices = []
            this.gettingDevices = false
      });
    },
    // Delete Device
    deleteDevice(_device, _index){
      if (!confirm(`Delete device '${_device.name}'?`)){
        return
      }
      this.devicesMessage = "Deleting device..."
      this.deletingDevice = true
      const params = {uid: _device.uid, devtype: this.device_type}
      const dest = this.site + '/suite/devices/deleteDevice'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          this.deletingDevice = false
          var rm = this.devices.splice(_index, 1)
          alert('Deleted device.')
          this.devicesMessage = "..."
          this.getDevices()
        })
        .catch(error => {
          try {             
              alert(error.response.data.errorMessage)
          } catch (error) {
              alert("Failed connection with server, check your connection.")
          }
          // Some Error
          this.deletingDevice = false
          this.devicesMessage = "..."
        });
    },
    // Edit Device
    setEdition(_device, _index){
      // Set the data.
      this.editedDevice = _device
      this.editedDevice.index = _index
      this.editionMode = true
      this.editNumber = _index + 1
      this.editName = _device.name
      this.editAlias = _device.alias
      this.editSerkey = _device.service_key
      this.editTicket = _device.ticket
      this.editCity = {name: _device.city, uid: _device.city_uid}
      this.editRole = {name: _device.role, uid: _device.role_uid, category: _device.category}
      this.editCred = _device.credential
      this.editLocatorKey += 1
      this.editCenterLatitude = parseFloat(_device.latitude)
      this.editCenterLongitude = parseFloat(_device.longitude)
      this.editDeviceMarker.position.lat = parseFloat(_device.latitude)
      this.editDeviceMarker.position.lng = parseFloat(_device.longitude)
      this.editDeviceMarker.icon = _device.role
      this.editDeviceMarker.type = _device.role
      this.editDeviceMarker.size = this.icons_sa[_device.role].size
      this.editDeviceMarker.anchor = this.icons_sa[_device.role].anchor
      this.editDeviceMarker.draggable = true
      // Retrieve credentials for edition.
      if (!this.credless_cats.includes(_device.category)){
        this.getCredentials('edition')
      }
    },
    clearEdition(){
      this.editDeviceMarker = this.cloneObject(this.defaultMarker)
      this.editionMode = false
      this.content_mode = this.content_mode.replace('edition','main')
    },
    setEditIcon(){
      if (typeof(this.editRole) == 'object'){
        this.editDeviceMarker.size = this.icons_sa[this.editRole.name].size
        this.editDeviceMarker.anchor = this.icons_sa[this.editRole.name].anchor
        this.editDeviceMarker.icon = this.editRole.name
      }
    },
    editDevice(){
      this.alteringDevice = true
      this.editDeviceMarker.draggable = false
      this.devicesMessage = "Modifying device..."
      // Send modification.
      const params = {
        uid: this.editedDevice.uid,
        ip: this.editedDevice.ip,
        name: this.editedDevice.name,
        alias: this.editAlias,
        os: this.editedDevice.os,
        role: this.editRole.uid,
        city: this.editCity.uid,
        latitude: this.editDeviceMarker.position.lat,
        longitude: this.editDeviceMarker.position.lng,
        devtype: this.device_type,
        credential: this.editCred,
        ticket: this.editTicket,
        service_key: this.editSerkey
      }
      const dest = this.site + '/suite/devices/editDevice'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          this.getDevices()
          this.clearEdition()
          this.alteringDevice = false
          alert(rx.data.message)
          this.devicesMessage = "..."
        })
        .catch(error => {
          try {             
              alert(error.response.data.errorMessage)
          } catch (error) {
              alert("Failed connection with server, check your connection:" + String(error) )
          }
          // Some Error
          this.alteringDevice = false
          this.editDeviceMarker.draggable = true
          this.devicesMessage = "..."
        });


    },
    alternActive(_device, _index){
      if (!confirm(`Change status of '${_device.name}'?`)){
        return
      }
      this.devicesMessage = "Modifying device status..."
      this.alteringDevice = true
      const params = {uid: _device.uid, active: !_device.active}
      const dest = this.site + '/suite/devices/alternActive'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          this.alteringDevice = false
          this.devicesMessage = "..."
          this.getDevices()
        })
        .catch(error => {
          this.devicesMessage = this.processErrorMessage(error)
          this.alteringDevice = false
        });
      
    },
    // New Device
    setOnlineMode(){
      this.online_mode = !this.online_mode
      this.clearNew()
      if (!this.online_mode){
        this.newDeviceOs = 'superficial'
        this.noa.os = 'superficial'
        this.noa.marker.draggable = true
        this.newDeviceMarker.draggable = true
        this.deviceFound = true
      }
    },
    addDevice(){
      if (this.deviceFound == false){
        return
      }
      //if (this.newDeviceIP == ""){
      //  alert('Invalid IP...')
      //  return
      //}
      //if (this.newDeviceAlias == ""){
      //  alert('Invalid alias...')
      //  return
      //}
      if (!this.noa.ip){
        alert('Invalid/empty IP.')
        return
      }
      if (!this.noa.name){
        alert('Invalid/empty name.')
        return
      }

      if (!this.noa.alias){
        alert('Invalid/empty alias.')
        return
      }
      if (!this.noa.city){
        alert('Select a city.')
        return
      }
      if (!this.noa.role){
        alert('Select a role.')
        return
      }

      //if (this.newCity == "invalid"){
      //  alert('Select a city...')
      //  return
      //}
      //if (this.newRole == "role"){
      //  alert('Select a role...')
      //  return
      //}
      // Set the json.
      this.addingDevice = true
      this.message = "Adding device, please wait..."
      this.newDeviceMarker.draggable = false
      const params = {
        //ip: this.newDeviceIP,
        ip: this.noa.ip,
        //name: this.newDeviceName,
        name: this.noa.name,
        //alias: this.newDeviceAlias,
        alias: this.noa.alias,
        os: this.noa.os,
        ticket: this.noa.ticket,
        service_key: this.noa.serkey,
        //role: this.newRole.uid,
        //city: this.newCity.uid,
        city: this.noa.city.uid,
        role: this.noa.role.uid,
        //latitude: this.newDeviceMarker.position.lat,
        //longitude: this.newDeviceMarker.position.lng,
        latitude: this.noa.marker.position.lat,
        longitude: this.noa.marker.position.lng,
        credential: this.selected_credential,
        devtype: this.device_type,
        in_svc: 1
      }
      const dest = this.site + '/suite/devices/addDevice'
      axios
        .post(dest, {params})
        .then(rx => {
          // OK
          this.clearNew()
          //this.getDevices()
          alert(rx.data.message)
        })
        .catch(error => {
          this.message = this.processErrorMessage(error)
          // Some Error
          this.addingDevice = false
          this.newDeviceMarker.draggable = true
        });


    },
    clearNew(){
      this.locatorKey += 1
      this.newDeviceIP = ""
      this.newDeviceName = "..."
      this.newDeviceAlias = "..."
      this.newDeviceOs = "os"
      this.newCity = "invalid"
      this.newRole = "role"
      this.message = ""
      this.newDeviceMarker = this.cloneObject(this.defaultMarker)
      this.addingDevice = false
      this.deviceFound = false
      this.credentials = []
      this.selected_credential = null
      this.clearNOA()
      if(!this.online_mode){ this.noa.os = 'superficial'; this.noa.marker.draggable = true; this.noa.name = null; this.noa.alias= null; this.deviceFound = true;}
    },
    clearNOA(){ 
      this.noa = this.cloneObject(this.defnoa)
      this.noa.marker = this.cloneObject(this.defaultMarker)
      this.locatorKey += 1
      this.addingDevice = false
      this.deviceFound = false
      this.credentials = []
      this.selected_credential = null
      this.block_role = false
      this.block_ip = false
    },
    inspectDevice(){
      //if (this.newDeviceIP == ""){
      //  alert('Empty device IP.')
      //  return
      //}
      if (!this.noa.ip){
        alert('Empty device IP.')
        return
      }
      this.inspectingDevice = true
      this.message = "Searching device, please wait..."
      //const params = {ip: this.newDeviceIP, origin: this.newRole.category, uid:this.selected_credential }
      const params = {ip: this.noa.ip, origin: this.noa.role.category, uid:this.selected_credential }
      const dest = this.site + '/suite/devices/inspectDevice'
      axios
        .get(dest, {params})
        .then(rx => {
          // OK
          this.inspectingDevice = false
          this.deviceFound = rx.data.inspection.deviceFound
          this.newDeviceName = rx.data.inspection.hostname
          this.noa.name = rx.data.inspection.hostname
          this.newDeviceAlias = ''
          this.newDeviceOs = rx.data.inspection.device_os
          this.noa.os = rx.data.inspection.device_os
          this.block_role = true
          this.block_ip = true
          this.newDeviceMarker.draggable = true
          this.noa.marker.draggable = true
          this.message = "Device found, complete the information."
        })
        .catch(error => {
            this.message = this.processErrorMessage(error)
            this.inspectingDevice = false
            this.deviceFound = false
            this.block_role = false
            this.block_ip = false
          });
    },
    pingDevice(){
      if (this.newDeviceIP == ""){
        alert('Empty device IP.')
        return
      }
    },
    setIcon(){
      if (typeof(this.newRole) == 'object'){
        this.newDeviceMarker.size = this.icons_sa[this.newRole.name].size
        this.newDeviceMarker.anchor = this.icons_sa[this.newRole.name].anchor
        this.newDeviceMarker.icon = this.newRole.name
      }
      else{
        // String default
        this.newDeviceMarker.size = this.icons_sa[this.newRole].size
        this.newDeviceMarker.anchor = this.icons_sa[this.newRole].anchor
        this.newDeviceMarker.icon = this.newRole
      }
    },
    setIcon(){
      //console.log('ROLE:',this.noa.role)
      
      if (!this.noa.role){
        this.noa.marker = this.defaultMarker
      }
      else if (typeof(this.noa.role) == 'object'){
        this.noa.marker.size = this.icons_sa[this.noa.role.name].size
        this.noa.marker.anchor = this.icons_sa[this.noa.role.name].anchor
        this.noa.marker.icon = this.noa.role.name
      }
      else{
        // String default
        this.noa.marker.size = this.icons_sa[this.noa.role].size
        this.noa.marker.anchor = this.icons_sa[this.noa.role].anchor
        this.noa.marker.icon = this.noa.role
      }
    },
    getImage(base){
      if (base == null){
        return this.bases.unknown
      }
      else if (typeof(base) == 'object'){
        return this.bases[base.name]
      }
      else{
        return this.bases[base]
      }
    },
    // Credentials
    getCredentials(MODE='new'){
      // Validation.
      const params = {type:null}
      //if(MODE == 'new'){
      //  this.credentials = []
      //  if (this.newRole == "role"){ return }
      //  if (this.newRole.name == 'other'){ return }
      //  if (!this.online_mode){ return }
      //  params.type = this.newRole.category
      //}
      //else{
      //  params.type = this.editRole.category
      //  this.credentials_fed = []
      //}
      if(MODE == 'new'){
        this.credentials = []
        if (!this.noa.role){ return }
        if (this.noa.role.name == 'other'){ return }
        if (!this.online_mode){ return }
        params.type = this.noa.role.category
      }
      else{
        this.credentials_fed = []
        params.type = this.editRole.category
      }

      // Execution.
      this.gettingCredentials = true
      const dest = this.site + '/suite/devices/getInspectionCredentials'
      axios
          .get(dest, {params})
          .then(rx => {
            // OK
            this.credentials = rx.data.credentials
            this.credentials_fed = rx.data.credentials
            this.gettingCredentials = false
          })
          .catch(error => {
              try {             
                  alert(error.response.data.errorMessage)
              } catch (error) {
                  alert("Failed connection with server, check your connection.")
              }
              this.gettingCredentials = false
      });
    },
    // Massive Addition
    clearFileInput(){
      var excelForm = document.getElementById('excelForm')
      excelForm.reset()
    },
    clearMassive(){
      this.clearFileInput()
      this.details = []
      this.uploadMessage = ""
      this.uploadedCompleted = false
      this.uploadingFile = false
    },
    uploadDevicesFile(){
      // --- Validation
      var xfile = document.querySelector('#devicesFile')
      if (xfile.files.length == 0){
        alert('Please load a file.')
        return
      }
      // --- Preparing data.
      this.uploadingFile = true
      this.details = []
      this.uploadMessage = ""
      var fileForm = new FormData();
      fileForm.append("devices", xfile.files[0])
      // Sending request.
      const dest = this.site + '/suite/devices/uploadDevicesFile'
      axios
        .post(dest, fileForm, { headers: {'Content-Type': 'multipart/form-data'} })
        .then(rx => {
          // OK
          this.uploadingFile = false
          this.uploadedCompleted = rx.data.completed
          this.uploadMessage = rx.data.message
          this.details = rx.data.details
          if(this.uploadedCompleted == true){
            alert(this.uploadMessage)
            this.clearMassive()
          }
        })
        .catch(error => {
            this.processErrorMessage(error)
            this.uploadingFile = false
            this.uploadedCompleted = false
          });

    },

    askLocation(ref){
        return this.$refs[ref].sendLocation()
    },
    // Cities & Roles
    getCities(){
      this.gettingCities = true
      const params = {}
      const dest = this.site + '/suite/devices/getCities'
      axios
          .get(dest, {params})
          .then(rx => {
            this.cities = rx.data.cities
            this.gettingCities = false
          })
          .catch(error => {
            try {             
                alert(error.response.data.errorMessage)
            } catch (error) {
                alert("Failed connection with server, check your connection.")
            }
            this.gettingCities = false
      });
    },
    getRoles(){
      this.gettingRoles = true
      const params = {type:this.device_type}
      const dest = this.site + '/suite/devices/getRoles'
      axios
          .get(dest, {params})
          .then(rx => {
            this.roles = rx.data.roles
            this.gettingRoles = false
          })
          .catch(error => {
            try {             
                alert(error.response.data.errorMessage)
            } catch (error) {
                alert("Failed connection with server, check your connection.")
            }
            this.gettingRoles = false
      });
    },
    // For the map
    getMapKey(){
        const params = {}
        const dest = this.site + '/suite/devices/getMapKey'
        axios
            .get(dest, {params})
            .then(rx => {
                this.mapKey = rx.data.key
            })
            .catch(error => {
                try {             
                    alert(error.response.data.errorMessage)
                } catch (error) {
                    alert("Failed connection with server, check your connection.")
                }
            });
    },
    // Searching
    setSearchType(search_type){
      this.searchType = search_type
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },
    // -- Miscellaneous
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.exampleExcelFile = `${this.site}/suite/devices/getMassiveExampleFile`
    this.getMapKey()
    this.getCities()
    //this.getDevices()
    //this.getRoles()
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  },
  computed: {
    filteredDevices(){
        if (this.searchWord == ''){
            return this.devices
        }
        this.searchWord = this.searchWord.toLowerCase()
        return this.devices.filter( device => String(device[this.searchType]).toLowerCase().includes( this.searchWord ) );
    },
    filtered(){
        if (this.search_word == '' || this.search_word == null){
            return this.devices
        }
        this.search_word = this.search_word.toLowerCase()
        return this.devices.filter( device => String(device[this.search_by]).toLowerCase().includes( this.search_word ) );
    }
  }
}
</script>

<style scoped>

  .border-kraken{
    border-top: solid 1px rgb(20, 63, 162);
    border-bottom: solid 1px rgb(20, 63, 162);
    border-left: solid 1px rgb(20, 63, 162);
    border-right: solid 1px rgb(20, 63, 162);
  }
  .border-bottom-kraken{
    border-bottom: solid 1px rgb(20, 63, 162);
  }
  .border-end-kraken{
    border-right: solid 1px rgb(20, 63, 162);
  }
  .border-top-suite{
    border-top: solid 2px rgb(0, 48, 90);
  }

  .btn-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    transition-duration: 0.5s;
    text-shadow: 3px 5px 4px Black;
    border-left: solid 6px transparent;
    border-right: solid 6px transparent;
  }
  .btn-suite:hover{
    color: rgb(0, 179, 255);
    background-color: rgb(1, 77, 144);
  }

  .selected-type{
    border-left: solid 6px rgb(0, 179, 255);
    color: rgb(0, 179, 255);
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  /* we will explain what these classes do next! */
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.7s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 1s ease;
  }

  /* Table with static header */
  .tableFixHead {
      overflow-y: auto;
    }
  .tableFixHead thead th {
      position: sticky;
      top: 0;
      text-align: center;
      z-index: 1;
  }
  table {
      border-collapse: collapse;
      width: 100%;
  }
  th, td {
      padding: 8px 16px;
  }
  th {
      background: #eee;
  }

  .bg-input{
      background-color: rgb(7,13,15);
      color: white;
  }
  .temporal-disable{
      opacity: 0.5;
      pointer-events: none;
  }
  .btn-kraken{
      background-color: rgb(20, 63, 162);
      color: white;
      transition-duration: 0.5s;
      text-shadow: 3px 5px 4px Black;
      border-left: solid 3px transparent;
      border-right: solid 3px transparent;
  }
  .btn-kraken:hover{
      background-color: rgb(0, 17, 39);
      color: rgb(0, 211, 249);
  }
  .bg-kraken{
      background-color: rgb(20, 63, 162);
      color: white;
      transition-duration: 0.5s;
      text-shadow: 3px 5px 4px Black;
      border-left: solid 3px transparent;
      border-right: solid 3px transparent;
  }

</style>
